//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  name: 'DataLogCompareModal',
  data: function data() {
    return {
      modalWidth: 1000,
      modaltoggleFlag: true,
      confirmDirty: false,
      title: '操作',
      visible: false,
      model: {},
      confirmLoading: false,
      headers: {},
      //版本号
      dataVersion1Num: '',
      dataVersion2Num: '',
      //表头
      columns: [{
        title: '字段名',
        align: 'left',
        dataIndex: 'code',
        width: '30%'
      }, {
        align: 'left',
        dataIndex: 'dataVersion1',
        width: '30%',
        slots: {
          title: 'dataVersionTitle1'
        }
      }, {
        title: '',
        dataIndex: 'imgshow',
        align: 'center',
        scopedSlots: {
          customRender: "avatarslot"
        },
        width: '10%'
      }, {
        align: 'left',
        dataIndex: 'dataVersion2',
        width: '30%',
        slots: {
          title: 'dataVersionTitle2'
        }
      }],
      //数据集
      dataSource: [],
      loading: false,
      url: {
        queryCompareUrl: "/sys/dataLog/queryCompareList"
      }
    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(dataId1, dataId2) {
      var _this = this;

      this.dataSource = [];
      var that = this;
      getAction(that.url.queryCompareUrl, {
        dataId1: dataId1,
        dataId2: dataId2
      }).then(function (res) {
        if (res.success) {
          that.dataVersion1Num = res.result[0].dataVersion;
          that.dataVersion2Num = res.result[1].dataVersion;
          var json1 = JSON.parse(res.result[0].dataContent);
          var json2 = JSON.parse(res.result[1].dataContent);

          for (var item1 in json1) {
            for (var item2 in json2) {
              if (item1 == item2) {
                _this.dataSource.push({
                  code: item1,
                  imgshow: '',
                  dataVersion1: json1[item1],
                  dataVersion2: json2[item2]
                });
              }
            }
          }
        } else {
          console.log(res.message);
        }
      });
    },
    compareModal: function compareModal(dataId1, dataId2) {
      this.visible = true;
      this.loadData(dataId1, dataId2);
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    modalFormOk: function modalFormOk() {},
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
    },
    setdataCss: function setdataCss(record) {
      var className = 'trcolor';
      var dataVersion1 = record.dataVersion1;
      var dataVersion2 = record.dataVersion2;

      if (dataVersion1 != dataVersion2) {
        return className;
      }
    },
    getAvatarView: function getAvatarView(avatar) {
      if (avatar.dataVersion1 != avatar.dataVersion2) {
        return "/goright.png";
      } else {
        return "";
      }
    }
  }
};